// extracted by mini-css-extract-plugin
export default {"table":"InspectionStatisticTable_table__Ic1MR"};